<app-nav-bar></app-nav-bar>
<app-boards></app-boards>
<app-thriflogs-table></app-thriflogs-table>